/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrition-ip.reducer';

export const NutritionIPDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionIPEntity = useAppSelector(state => state.nutritionIP.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionIPDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionIP.detail.title">NutritionIP</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.id}</dd>
          <dt>
            <span id="label">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.label">Label</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.label}</dd>
          <dt>
            <span id="tag">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.tag">Tag</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.tag}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.description">Description</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.description}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.unit}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.timestampentry}</dd>
          <dt>
            <span id="rdi">
              <Translate contentKey="tinyMedicRestApp.nutritionIP.rdi">Rdi</Translate>
            </span>
          </dt>
          <dd>{nutritionIPEntity.rdi ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/nutrition-ip" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrition-ip/${nutritionIPEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionIPDetail;
